import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Icon from "@amzn/meridian/esm/components/icon";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import errorTokens from "@amzn/meridian-tokens/base/icon/error";
import star from "../../images/star.svg";
import { THEME_COLOR } from "../../styles/colors";
import WaveformLayout from "../../components/waveformLayout/WaveformLayout";
import { scaleIconClass } from "../../styles/icon.styles";
import { WAVEFORM_ICON_SCALE } from "../../constants";

const RtmsRejected = ({ rtmsRequesterName }) => {
  return (
    <Column spacing="400">
      <WaveformLayout icon={<Icon className={scaleIconClass(WAVEFORM_ICON_SCALE)} tokens={errorTokens} color="error" />} />
      <Row alignmentHorizontal="center" spacing="none">
        <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.LIGHT_TEAL }}>
          <Box type="outline" width="252px" spacingInset="400">
            <Row spacing="300" alignmentVertical="top">
              <img src={star} alt="star" />
              <Column spacing="none">
                <Text type="h50" alignment="start">
                  {rtmsRequesterName}
                </Text>
                <Text type="b200" alignment="start">
                  is starting summary...
                </Text>
              </Column>
            </Row>
          </Box>
        </Theme>
      </Row>
    </Column>
  );
};

export default RtmsRejected;
